var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "147.708333px",
    viewBox: "0 0 134 147.708333",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,11 L16.5,19 C16.5,25.5 22,30.5 28,30.5 L94,30.5 C100.5,30.5 105.5,25 105.5,19 L105.5,11 L106,11 C115,11 122,18.5 122,27.5 L122.000646,65.2648097 C113.821715,59.4315095 103.811594,56 93,56 C84.7784702,56 77.0204025,57.984317 70.1785978,61.50015 L28.5,61.5 C26.5,61.5 24.5,63 24.5,65.5 C24.5,67.5 26,69.5 28.5,69.5 L58.8272806,69.5001083 C55.2472654,72.8532381 52.1608448,76.7269783 49.688783,81.0005649 L28.5,81 C26.5,81 24.5,82.5 24.5,85 C24.5,87 26,89 28.5,89 L45.9642852,88.9999049 C44.0458478,94.3068271 43,100.031278 43,106 C43,118.887289 47.8756095,130.635818 55.882878,139.501638 L16,139.5 C7.5,139.5 7.10542736e-15,132.5 7.10542736e-15,123.5 L7.10542736e-15,27 C7.10542736e-15,18.5 7,11 16,11 L16.5,11 Z M91,7.10542736e-15 C94.5,7.10542736e-15 97.5,3 97.5,6.5 L97.5,16 C97.5,19.5 94.5,22.5 91,22.5 L31,22.5 C27.5,22.5 24.5,19.5 24.5,16 L24.5,6.5 C24.5,3 27.5,7.10542736e-15 31,7.10542736e-15 L91,7.10542736e-15 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,108.208333 L111,120.208333 L104,127.208333 L89.5,112.708333 L89,112.708333 L89,87.7083333 L99,87.7083333 L99,108.208333 Z M94,147.708333 C72,147.708333 54,129.708333 54,107.708333 C54,85.7083334 72,67.7083334 94,67.7083334 C116,67.7083334 134,85.7083334 134,107.708333 C134,129.708333 116,147.708333 94,147.708333 Z M94,137.708333 C110.5,137.708333 124,124.208333 124,107.708333 C124,91.2083334 110.5,77.7083334 94,77.7083334 C77.5,77.7083334 64,91.2083334 64,107.708333 C64,124.208333 77.5,137.708333 94,137.708333 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.77d9727af52489fc47056b3f2edc53eb.svg";
export { ForwardRef as ReactComponent };